module.exports = __webpack_public_path__ + "static/media/alert_2.b80625c4.svg";